import { dataProps, taxListProps } from './properties'

export const setExpenseJournalList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
if(!state.nav.had_results) {
   state.nav.had_results = payload.total>0
}
}    

export const setExpenseJournalData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.tax_list.length === 0) {
        state.props.tax_list = [JSON.parse(JSON.stringify(taxListProps))]
    }
} 

export const addNewExpenseJournalTaxListRow = state => {

    let key = 0
    state.props.tax_list.push(JSON.parse(JSON.stringify(taxListProps)))

    state.props.tax_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeExpenseJournalTaxListRow = (state, payload) => {

    let key = 0

    state.props.deleted_tax_list.push(state.props.tax_list[payload])

    state.props.tax_list.splice(payload, 1)

    if(state.props.tax_list.length === 0) {
        state.props.tax_list = [JSON.parse(JSON.stringify(taxListProps))]
    }

    state.props.tax_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const setExportExpenseData = (state, payload) => {
    state.export_expense = payload
}

export const resetExpenseJournalData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/expenseJournal/mutations.js